import './authorizedUsers.js';
import './bidStatus.js';
import './bulkLoadCardStatus.js';
import './misc.js';
import './event-names.js';
import './eventsMapObj.js';
import './Faq.js';
import './languages.js';
import './loadStatus.js';
import './lorryStatus.js';
import './lorryTypes.js';
import './mostSearchedLinks.js';
import './Pages.js';
import 'react';
import './serviceTypeId.js';
import './StateList.js';
import './bidUpdateType.js';
import './userAction.js';
import './api.js';
import './link.js';
import './market.js';
import './payment.js';
import './admin/screenId.js';
import '../_services/const.js';
import 'bowser';
import '../_virtual/_tslib.js';
import '../components/toast/toast.js';
import '../_services/auth.service.js';
import '../methods/getAuthIdParam.js';
import 'react-cookie';
import '../methods/formatDate.js';
import '../methods/getTransporterFigure.js';
import '../methods/getDownloadsFigure.js';
import 'lodash.isequal';
import '../methods/getPageLoadSourceUTMParam.js';
import { generateQueryString } from '../methods/generateQueryString.js';
import 'crypto-js';

const ROUTES = {
    transporterProfile: {
        withParam: "/transporters/:src/:transporterName/:transporterId",
        getUrl: (src, transporterName, transporterId) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            return `/transporters/profile/${(_c = (_b = (_a = src === null || src === void 0 ? void 0 : src.replace) === null || _a === void 0 ? void 0 : _a.call(src, / /g, "-")) === null || _b === void 0 ? void 0 : _b.toLowerCase) === null || _c === void 0 ? void 0 : _c.call(_b)}/${(_m = (_l = (_k = (_j = (_h = (_g = (_f = (_e = (_d = transporterName === null || transporterName === void 0 ? void 0 : transporterName.replace) === null || _d === void 0 ? void 0 : _d.call(transporterName, / /g, "-")) === null || _e === void 0 ? void 0 : _e.replace) === null || _f === void 0 ? void 0 : _f.call(_e, /,/g, "-")) === null || _g === void 0 ? void 0 : _g.replace) === null || _h === void 0 ? void 0 : _h.call(_g, /--/g, "-")) === null || _j === void 0 ? void 0 : _j.replace) === null || _k === void 0 ? void 0 : _k.call(_j, /\s|\.|\//g, "-")) === null || _l === void 0 ? void 0 : _l.toLowerCase) === null || _m === void 0 ? void 0 : _m.call(_l)}/${transporterId}`;
        },
        getUrlWithId: (transporterId) => `/transporters/profile/${transporterId}`
    },
    transporterProfileDetail: {
        getUrl: (transporterId) => `/transporters/profile/detail/${transporterId}`
    },
    transporterReviews: {
        withParam: "/transporters/:src/:transporterName/:transporterId/reviews",
        getUrl: (src, transporterName, transporterId) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            return `/transporters/profile/${(_c = (_b = (_a = src === null || src === void 0 ? void 0 : src.replace) === null || _a === void 0 ? void 0 : _a.call(src, / /g, "-")) === null || _b === void 0 ? void 0 : _b.toLowerCase) === null || _c === void 0 ? void 0 : _c.call(_b)}/${(_m = (_l = (_k = (_j = (_h = (_g = (_f = (_e = (_d = transporterName === null || transporterName === void 0 ? void 0 : transporterName.replace) === null || _d === void 0 ? void 0 : _d.call(transporterName, / /g, "-")) === null || _e === void 0 ? void 0 : _e.replace) === null || _f === void 0 ? void 0 : _f.call(_e, /,/g, "-")) === null || _g === void 0 ? void 0 : _g.replace) === null || _h === void 0 ? void 0 : _h.call(_g, /--/g, "-")) === null || _j === void 0 ? void 0 : _j.replace) === null || _k === void 0 ? void 0 : _k.call(_j, /\./g, "")) === null || _l === void 0 ? void 0 : _l.toLowerCase) === null || _m === void 0 ? void 0 : _m.call(_l)}/${transporterId}/reviews`;
        }
    },
    marketplace: {
        withParam: [
            "/marketplace-ae/:mktType/to-:dest",
            "/marketplace-ae/:mktType/:src-to-:dest",
            "/marketplace-ae/:mktType/:src",
            "/marketplace-ae/:mktType",
            "/marketplace/:mktType/to-:dest",
            "/marketplace/:mktType/:src-to-:dest",
            "/marketplace/:mktType/:src",
            "/marketplace/:mktType"
        ],
        getUrl: (mktType, src, dest, isABtestingRoute) => {
            var _a, _b, _c, _d, _e, _f, _g;
            let url = "";
            if (src && dest) {
                url = `/marketplace/${mktType}/${src}-to-${dest}`;
            }
            else if (src) {
                url = `/marketplace/${mktType}/${src}`;
            }
            else if (dest) {
                url = `/marketplace/${mktType}/to-${dest}`;
            }
            else {
                url = `/marketplace/${mktType}`;
            }
            url = (_g = (_f = (_e = (_d = (_c = (_b = (_a = url === null || url === void 0 ? void 0 : url.replace) === null || _a === void 0 ? void 0 : _a.call(url, / /g, "-")) === null || _b === void 0 ? void 0 : _b.replace) === null || _c === void 0 ? void 0 : _c.call(_b, /,/g, "-")) === null || _d === void 0 ? void 0 : _d.replace) === null || _e === void 0 ? void 0 : _e.call(_d, /--/g, "-")) === null || _f === void 0 ? void 0 : _f.toLowerCase) === null || _g === void 0 ? void 0 : _g.call(_f);
            if (isABtestingRoute)
                url = url.replace("marketplace", "marketplace-ae");
            return url;
        }
    },
    loadBid: {
        withParam: ["/marketplace/load/:src-to-:dest#id"],
        getUrl: (src, dest, loadId, companyId) => {
            var _a, _b, _c, _d;
            return (_d = (_b = (_a = `/marketplace/load/${src}-to-${dest}?oppCmpId=${companyId}&loadbid=${loadId}`) === null || _a === void 0 ? void 0 : _a.replace) === null || _b === void 0 ? void 0 : (_c = _b.call(_a, / /g, "-")).toLowerCase) === null || _d === void 0 ? void 0 : _d.call(_c);
        }
    },
    lorryBid: {
        withParam: ["/marketplace/lorry/:src#id"],
        getUrl: (src, lorryId, companyId) => {
            var _a, _b, _c, _d;
            return (_d = (_c = (_b = (_a = `/marketplace/lorry/${src}?oppCmpId=${companyId}&lorrybid=${lorryId}`) === null || _a === void 0 ? void 0 : _a.replace) === null || _b === void 0 ? void 0 : _b.call(_a, / /g, "-")) === null || _c === void 0 ? void 0 : _c.toLowerCase) === null || _d === void 0 ? void 0 : _d.call(_c);
        }
    },
    bidHistory: {
        withParam: ["/:mktType-marketplace/bid-history"],
        getUrl: (mktType) => `/${mktType}-marketplace/bid-history`
    },
    transporters: {
        withParam: ["/transporters"],
        getUrl: (src, dest) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
            const baseUrl = "/transporters";
            src = (_g = (_f = (_e = (_d = (_c = (_b = (_a = src === null || src === void 0 ? void 0 : src.replace) === null || _a === void 0 ? void 0 : _a.call(src, / /g, "-")) === null || _b === void 0 ? void 0 : _b.replace) === null || _c === void 0 ? void 0 : _c.call(_b, /,/g, "-")) === null || _d === void 0 ? void 0 : _d.replace) === null || _e === void 0 ? void 0 : _e.call(_d, /--/g, "-")) === null || _f === void 0 ? void 0 : _f.toLowerCase) === null || _g === void 0 ? void 0 : _g.call(_f);
            dest = (_p = (_o = (_m = (_l = (_k = (_j = (_h = dest === null || dest === void 0 ? void 0 : dest.replace) === null || _h === void 0 ? void 0 : _h.call(dest, / /g, "-")) === null || _j === void 0 ? void 0 : _j.replace) === null || _k === void 0 ? void 0 : _k.call(_j, /,/g, "-")) === null || _l === void 0 ? void 0 : _l.replace) === null || _m === void 0 ? void 0 : _m.call(_l, /--/g, "-")) === null || _o === void 0 ? void 0 : _o.toLowerCase) === null || _p === void 0 ? void 0 : _p.call(_o);
            if (src && dest) {
                return `${baseUrl}/${src}-to-${dest}`;
            }
            if (src) {
                return `${baseUrl}/${src}`;
            }
            if (dest) {
                return `${baseUrl}/for-${dest}`;
            }
            return baseUrl;
        }
    },
    pageNotFound: {
        withParam: "/page-not-found",
        getUrl: () => "/page-not-found"
    },
    dashboard: {
        withParam: "/dashboard",
        getUrl: () => "/dashboard"
    },
    userProfile: {
        withParam: "/my-profile",
        getUrl: () => "/my-profile"
    },
    userProfileEdit: {
        withParam: "/my-profile/edit",
        getUrl: () => "/my-profile/edit"
    },
    adminConsole: {
        withParam: "/",
        getUrl: () => "/"
    },
    adminConsoleLogin: {
        withParam: "/login",
        getUrl: () => "/login"
    },
    adminConsoleExecutives: {
        withParam: "/executives",
        getUrl: () => "/executives"
    },
    adminConsoleRecords: {
        withParam: "/records",
        getUrl: () => "/records"
    },
    adminConsoleCustomer: {
        withParam: "/customer-login",
        getUrl: () => "/customer-login"
    },
    adminConsoleCustomerProfile: {
        withParam: "/customer-profile",
        getUrl: () => "/customer-profile"
    },
    adminConsoleCustomerProfileEdit: {
        withParam: "/customer-profile/edit",
        getUrl: () => "/customer-profile/edit"
    },
    adminConsoleCustomerMarketplace: {
        withParam: [
            "/customer-marketplace/:mktType/to-:dest",
            "/customer-marketplace/:mktType/:src-to-:dest",
            "/customer-marketplace/:mktType/:src",
            "/customer-marketplace/:mktType"
        ],
        getUrl: (mktType, src, dest) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            let url = "";
            if (src && dest) {
                url = (_d = (_c = (_b = (_a = `/customer-marketplace/${mktType}/${src}-to-${dest}`) === null || _a === void 0 ? void 0 : _a.replace) === null || _b === void 0 ? void 0 : _b.call(_a, / /g, "-")) === null || _c === void 0 ? void 0 : _c.toLowerCase) === null || _d === void 0 ? void 0 : _d.call(_c);
            }
            else if (src) {
                url = (_h = (_g = (_f = (_e = `/customer-marketplace/${mktType}/${src}`) === null || _e === void 0 ? void 0 : _e.replace) === null || _f === void 0 ? void 0 : _f.call(_e, / /g, "-")) === null || _g === void 0 ? void 0 : _g.toLowerCase) === null || _h === void 0 ? void 0 : _h.call(_g);
            }
            else if (dest) {
                url = (_k = (_j = `/customer-marketplace/${mktType}/to-${dest}`) === null || _j === void 0 ? void 0 : _j.toLowerCase) === null || _k === void 0 ? void 0 : _k.call(_j);
            }
            else {
                url = `/customer-marketplace/${mktType}`;
            }
            return url;
        }
    },
    adminConsoleEditProfile: {
        withParam: "/edit-profile",
        getUrl: () => "/edit-profile"
    },
    adminConsoleEditPassword: {
        withParam: "/edit-password",
        getUrl: () => "/edit-password"
    },
    adminConsoleCreateId: {
        withParam: "/executives/createid",
        getUrl: () => "/executives/createid"
    },
    adminConsoleBlockUsers: {
        withParam: "/block-users",
        getUrl: () => "/block-users"
    },
    adminConsoleSendWhatsAppMessage: {
        withParam: "/send-whatsapp-message",
        getUrl: () => "/send-whatsapp-message"
    },
    adminConsoleGlobalSearchResult: {
        withParam: "/search",
        getUrl: () => "/search"
    },
    adminConsolePremiumClients: {
        withParam: "/premium/client-list",
        getUrl: () => "/premium/client-list"
    },
    premiumLoadTrip: {
        withParam: `/premium/load-trip/`,
        getUrl: (loadId) => `/premium/load-trip/${loadId}`
    },
    premiumTripTrack: {
        withParam: `/premium/load-trip/track`,
        getUrl: () => `/premium/load-trip/track`
    },
    listing: {
        withParam: "/ac/my-loads/listing/:id",
        getUrl: (id) => `/ac/my-loads/listing/${id}`
    },
    myLoadsMyLorries: {
        withParam: [
            "/ac/my-:mktType/:activeTab/to-:dest",
            "/ac/my-:mktType/:activeTab/:src-to-:dest",
            "/ac/my-:mktType/:activeTab/:src",
            "/ac/my-:mktType/:activeTab"
        ],
        getUrl: (mktType, activeTab, src, dest) => {
            var _a;
            let url = "";
            if (src && dest) {
                url = (_a = `/ac/my-${mktType}/${activeTab}/${src}-to-${dest}`.replace(/ /g, "-")) === null || _a === void 0 ? void 0 : _a.toLowerCase();
            }
            else if (src) {
                url = `/ac/my-${mktType}/${activeTab}/${src}`.replace(/ /g, "-").toLowerCase();
            }
            else if (dest) {
                url = `/ac/my-${mktType}/${activeTab}/to-${dest}`.replace(/ /g, "-").toLowerCase();
            }
            else {
                url = `/ac/my-${mktType}/${activeTab}`;
            }
            return url;
        }
    },
    adminConsoleMyLoadsMyLorries: {
        withParam: [
            "/customer-:mktType/:activeTab/to-:dest",
            "/customer-:mktType/:activeTab/:src-to-:dest",
            "/customer-:mktType/:activeTab/:src",
            "/customer-:mktType/:activeTab"
        ],
        getUrl: (mktType, activeTab, src, dest) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            let url = "";
            if (src && dest) {
                url = (_d = (_c = (_b = (_a = `/customer-${mktType}/${activeTab}/${src}-to-${dest}`) === null || _a === void 0 ? void 0 : _a.replace) === null || _b === void 0 ? void 0 : _b.call(_a, / /g, "-")) === null || _c === void 0 ? void 0 : _c.toLowerCase) === null || _d === void 0 ? void 0 : _d.call(_c);
            }
            else if (src) {
                url = (_h = (_g = (_f = (_e = `/customer-${mktType}/${activeTab}/${src}`).replace) === null || _f === void 0 ? void 0 : _f.call(_e, / /g, "-")) === null || _g === void 0 ? void 0 : _g.toLowerCase) === null || _h === void 0 ? void 0 : _h.call(_g);
            }
            else if (dest) {
                url = (_k = (_j = `/customer-${mktType}/${activeTab}/to-${dest}`) === null || _j === void 0 ? void 0 : _j.toLowerCase) === null || _k === void 0 ? void 0 : _k.call(_j);
            }
            else {
                url = `/customer-${mktType}/${activeTab}`;
            }
            return url;
        }
    },
    help: {
        withParam: "/help",
        getUrl: () => "/help"
    },
    paymentList: {
        withParam: `/premium/payment-list`,
        getUrl: () => `/premium/payment-list`
    },
    adminConsoleTrackScreen: {
        withParam: `/track-vehicle`,
        getUrl: () => `/track-vehicle`
    },
    adminConsoleMobileViewHome: {
        withParam: `/mw`,
        getUrl: () => `/mw`
    },
    adminConsoleMobileViewTrackScreen: {
        withParam: `/mw/track-vehicle`,
        getUrl: () => `/mw/track-vehicle`
    },
    adminConsoleMobileViewPhysicalVerifyDoc: {
        withParam: `/mw/physical-verify-doc`,
        getUrl: (ticketId) => {
            let url = `/mw/physical-verify-doc`;
            if (ticketId) {
                url = `${url}/${ticketId}`;
            }
            return url;
        }
    },
    adminConsoleMobileViewMyReferral: {
        withParam: `/mw/my-referral`,
        getUrl: (isNew = false, cid = "") => {
            let url = `/mw/my-referral`;
            if (isNew && !cid) {
                url += "/new";
            }
            if (cid && !isNew) {
                url += `/my-user/${cid}`;
            }
            return url;
        }
    },
    adminConsoleMobileViewAssuredLoadPosted: {
        withParam: `/mw/tso/load/assured-spot`,
        getUrl: () => `/mw/tso/load/assured-spot`
    },
    adminConsoleMobileViewLoadPosted: {
        withParam: `/mw/tso/load/active`,
        getUrl: () => `/mw/tso/load/active`
    },
    adminConsoleMobileViewInTransitLoads: {
        withParam: `/mw/tso/load/in-transit`,
        getUrl: () => `/mw/tso/load/in-transit`
    },
    adminConsoleMobileViewLorryPosted: {
        withParam: `/mw/tso/lorry/active`,
        getUrl: () => `/mw/tso/lorry/active`
    },
    adminConsoleMobileViewInTransitLorries: {
        withParam: `/mw/tso/lorry/in-transit`,
        getUrl: () => `/mw/tso/lorry/in-transit`
    },
    adminConsoleTsoUserLoadOrLorryDetailsPage: {
        withParam: `/mw/tso/:mktType/detail/:entityId`,
        getUrl: (mktType, entityId) => {
            return `/mw/tso/${mktType}/detail/${entityId}`;
        }
    },
    adminConsoleMobileViewMarket: {
        withParam: `/mw/tso/market/:mktType`,
        getUrl: (mktType) => {
            return `/mw/tso/market/${mktType}`;
        }
    },
    adminConsoleMobileViewEnquiryCards: {
        withParam: `/mw/tso/:type/enquiry-cards`,
        getUrl: (type) => `/mw/tso/${type}/enquiry-cards`
    },
    adminConsoleMobileViewEnquiryCardLorriesList: {
        withParam: `/mw/tso/:type/enquiry-cards/live-lorries`,
        getUrl: (type) => `/mw/tso/load/enquiry-cards/live-lorries`
    },
    adminConsoleMobileViewEnquiryCardLoadsList: {
        withParam: `/mw/tso/:type/enquiry-cards/live-loads`,
        getUrl: (type) => `/mw/tso/lorry/enquiry-cards/live-loads`
    },
    adminMobileViewScreen: {
        withParam: `/mw/tso/:name/`,
        getUrl: (name) => `/mw/tso/${name}`
    },
    tsmCashbackStatus: {
        withParam: "/cashback-status",
        getUrl: () => "/cashback-status"
    },
    transporterHome: {
        withParam: "/transporters",
        getUrl: () => "/transporters"
    },
    premiumBulkLoads: {
        withParam: "/premium/bulk-loads",
        getUrl: () => "/premium/bulk-loads"
    },
    premiumBulkLoadsById: {
        withParam: "/premium/bulk-loads",
        getUrl: (bulkId = "") => `/premium/bulk-loads/${bulkId}`
    },
    adminConsoleTicketSystem: {
        withParam: ["/ticket-system/:ticketType", "/ticket-system/:ticketType/:ticketId"],
        getUrl: (ticketType, ticketId) => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            let url = "";
            if (ticketType && ticketId) {
                url = (_d = (_c = (_b = (_a = `/ticket-system/${ticketType}/${ticketId}`).replace) === null || _b === void 0 ? void 0 : _b.call(_a, / /g, "-")) === null || _c === void 0 ? void 0 : _c.toLowerCase) === null || _d === void 0 ? void 0 : _d.call(_c);
            }
            else if (ticketType) {
                url = (_h = (_g = (_f = (_e = `/ticket-system/${ticketType}`).replace) === null || _f === void 0 ? void 0 : _f.call(_e, / /g, "-")) === null || _g === void 0 ? void 0 : _g.toLowerCase) === null || _h === void 0 ? void 0 : _h.call(_g);
            }
            return url;
        }
    },
    adminConsoleTapNgoLoadTicketSystem: {
        withParam: [`/ticket-system/loads/tap-n-go`, "/ticket-system/loads/tap-n-go/:loadId"],
        getUrl: (loadId) => {
            if (loadId) {
                return `/ticket-system/loads/tap-n-go/${loadId}`;
            }
            return `/ticket-system/loads/tap-n-go`;
        }
    },
    adminConsoleRefundRequestTicketSystem: {
        withParam: "/ticket-system/refund-request",
        getUrl: () => "/ticket-system/refund-request"
    },
    adminConsoleVasLeadsTicketSystem: {
        withParam: "/ticket-system/vas-leads",
        getUrl: () => "/ticket-system/vas-leads"
    },
    adminConsoleBidsWithDepositLead: {
        withParam: "/ticket-system/bids-with-deposit-lead",
        getUrl: () => "/ticket-system/bids-with-deposit-lead"
    },
    adminConsoleTicketSystemWithTicketType: {
        withParam: `/ticket-system/:type`,
        getUrl: (path) => {
            return `/ticket-system/${path}`;
        }
    },
    adminConsoleLoadTicketSystemWithTicketType: {
        withParam: `/ticket-system/loads/:type`,
        getUrl: (path, loadId, queryObj) => {
            let targetUrl = `/ticket-system/loads/${path}`;
            if (loadId) {
                targetUrl += `/${loadId}`;
            }
            if (queryObj) {
                targetUrl += `?${generateQueryString(queryObj)}`;
            }
            return targetUrl;
        }
    },
    adminConsoleCSUsers: {
        withParam: ["/cs-users", "/cs-users/:userId", "/cs-roles/add", "/cs-users/edit/:userId"],
        getUrl: (userId, actionType) => {
            let url = `/cs-users`;
            if (actionType === "add") {
                return `/cs-users/add`;
            }
            if (actionType === "edit" && userId && !isNaN(userId)) {
                return `/cs-users/edit/${userId}`;
            }
            if (userId) {
                return `/cs-users/${userId}`;
            }
            return url;
        }
    },
    adminConsoleCSRoles: {
        withParam: ["/cs-roles", "/cs-roles/:userType"],
        getUrl: (userType) => {
            let url = `/cs-roles`;
            if (userType) {
                url = `/cs-roles/${userType}`;
            }
            return url;
        }
    },
    adminConsoleCSAttendance: {
        withParam: ["/cs-attendance"],
        getUrl: () => {
            let url = `/cs-attendance`;
            return url;
        }
    },
    membership: {
        withParam: "/membership/",
        getUrl: () => "/membership/"
    },
    membershipHistory: {
        withParam: "/membership/history",
        getUrl: () => "/membership/history"
    },
    membershipUpgrade: {
        withParam: "/membership/upgrade",
        getUrl: () => "/membership/upgrade"
    },
    membershipPayment: {
        withParam: "/membership/payment",
        getUrl: () => "/membership/payment"
    },
    membershipFeatures: {
        withParam: "/membership/features",
        getUrl: () => "/membership/features"
    },
    adminConsolePaymentReportSystem: {
        withParam: ["/payment-report/:reportType", "/payment-report/:reportType/:reportId"],
        getUrl: (reportType, reportId) => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            let url = "";
            if (reportType && reportId) {
                url = (_d = (_c = (_b = (_a = `/payment-report/${reportType}/${reportId}`).replace) === null || _b === void 0 ? void 0 : _b.call(_a, / /g, "-")) === null || _c === void 0 ? void 0 : _c.toLowerCase) === null || _d === void 0 ? void 0 : _d.call(_c);
            }
            else if (reportType) {
                url = (_h = (_g = (_f = (_e = `/payment-report/${reportType}`).replace) === null || _f === void 0 ? void 0 : _f.call(_e, / /g, "-")) === null || _g === void 0 ? void 0 : _g.toLowerCase) === null || _h === void 0 ? void 0 : _h.call(_g);
            }
            return url;
        }
    },
    adminMisc: {
        withParam: "/misc/:id",
        getUrl: (id) => `/misc/${id}`
    },
    adminTicketTsoLead: {
        withParam: ["/tso-admin/leads"],
        getUrl: () => {
            let url = `/tso-admin/leads`;
            return url;
        }
    },
    adminTicketTsoSessions: {
        withParam: ["/tso-admin/sessions"],
        getUrl: (companyId, timestamp) => {
            let url = `/tso-admin/sessions`;
            if (companyId && timestamp) {
                url = url + `/${companyId}/${timestamp}`;
            }
            return url;
        }
    },
    adminConsolePathWithScreenId: {
        withParam: ["/:screenId"],
        getUrl: (screenId) => {
            let url = `/${screenId}`;
            return url;
        }
    }
};

export { ROUTES };
//# sourceMappingURL=routeStrings.js.map
